import { createFileRoute } from '@tanstack/react-router'
import { ShareCashbackPage } from '~/features/admin/share-cashback-page'

export const Route = createFileRoute('/admin/share-cashback')({
  component: ShareCashbackPage,
})
